var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsertText = function SvgInsertText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.35 15.6V9.7h-2.7V8.4h6.7v1.3h-2.7v5.9zm-9.458 6.508v-5.116H3.8V7.008H1.892V1.892h5.116V3.8h9.984V1.892h5.116v5.116H20.2v9.984h1.908v5.116h-5.116V20.2H7.008v1.908zM7.008 18.9h9.984v-1.908H18.9V7.008h-1.908V5.1H7.008v1.908H5.1v9.984h1.908zM3.192 5.708h2.516V3.192H3.192zm15.1 0h2.516V3.192h-2.516zm0 15.1h2.516v-2.516h-2.516zm-15.1 0h2.516v-2.516H3.192z"
  })));
};
export default SvgInsertText;